import React from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Table, Badge, FeaturePlaceholder } from '@/components/ui';
import { useAttendanceShifts } from './hooks/useAttendance';
import { useAuth } from '@/core/auth/AuthContext';

export default function AttendanceShiftsPage() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  
  const { data: shifts = [], isLoading } = useAttendanceShifts(companyId);

  return (
    <PageLayout
      title="Cấu hình Ca làm việc"
      description="Thiết lập các khung giờ làm việc tiêu chuẩn và thời gian nghỉ ngơi."
      breadcrumbs={[{ label: 'Chấm công', path: '/maintenance/attendance' }, { label: 'Ca làm việc' }]}
      isLoading={isLoading}
      headerActions={
        <Button variant="primary" icon="ri-add-line">Thêm ca mới</Button>
      }
    >
      <div className="space-y-6">
        <Card className="overflow-hidden border-none shadow-sm">
          <Table
            columns={[
              { key: 'name', title: 'Tên ca' },
              { key: 'time', title: 'Khung giờ' },
              { key: 'break', title: 'Nghỉ giữa ca', align: 'center' },
              { key: 'status', title: 'Mặc định', align: 'center' },
              { key: 'actions', title: '', align: 'right' },
            ]}
            data={shifts}
            isLoading={isLoading}
            renderCell={(item, key) => {
              switch (key) {
                case 'name':
                  return <span className="font-bold text-slate-900">{item.name}</span>;
                case 'time':
                  return <span className="text-sm font-medium text-os-primary">{item.start_time} - {item.end_time}</span>;
                case 'break':
                  return <span className="text-xs text-slate-500">{item.break_minutes} phút</span>;
                case 'status':
                  return item.is_default ? <Badge variant="success">Mặc định</Badge> : null;
                case 'actions':
                  return (
                    <div className="flex justify-end gap-1">
                      <Button variant="ghost" size="sm" icon="ri-edit-line" />
                      <Button variant="ghost" size="sm" icon="ri-delete-bin-line" className="text-red-400" />
                    </div>
                  );
                default:
                  return null;
              }
            }}
          />
          
          {shifts.length === 0 && !isLoading && (
            <div className="py-20">
              <FeaturePlaceholder 
                title="Ca làm việc" 
                description="Hệ thống chấm công sẽ tự động tính toán giờ công dựa trên ca làm việc mà nhân viên được gán."
              />
            </div>
          )}
        </Card>
      </div>
    </PageLayout>
  );
}
